import { TokenProvider, TokenResponse } from '@fluidx/office-fluid-types';

const odspPushServiceScope = 'https://pushchannel.1drv.ms/pushchannel.readwrite.all';

export function getOdspStorageTokenScopes(siteUrl: string) {
  return [`${new URL(siteUrl).origin}/files.readwrite.all`];
}

export function getOdcStorageTokenScopes() {
  return ['onedrive.readwrite'];
}

export function getOdspSocketTokenScopes() {
  return [odspPushServiceScope];
}

/**
 * Prefetches the tokens required to host Fluid content stored in ODSP
 * @param tokenProvider An implementation of TokenProvider, which provides method for retrieving and caching tokens against scopes.
 * @param sites ODSP site URLs to prefetch tokens for.
 * @returns array of token promises for all prefetched resources
 */
export async function prefetchOdspTokens(tokenProvider: TokenProvider, sites: string[]): Promise<TokenResponse[]> {
  const tokenPromises = sites.map((site) => tokenProvider.getToken(getOdspStorageTokenScopes(site)));

  tokenPromises.push(tokenProvider.getToken(getOdspSocketTokenScopes()));

  return Promise.all(tokenPromises);
}

/**
 * Prefetches the tokens required to host Fluid content stored in ODC
 * @param tokenProvider An implementation of TokenProvider, which provides method for retrieving and caching tokens against scopes.
 * @param sites ODSP site URLs to prefetch tokens for.
 * @returns array of token promises for all prefetched resources
 */
export async function prefetchOdcTokens(tokenProvider: TokenProvider): Promise<TokenResponse[]> {
  return Promise.all([tokenProvider.getToken(getOdcStorageTokenScopes())]);
}
